import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1771d68f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "โครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบที่ได้รับ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบที่ใช้จริง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "เบิกจ่าย/ส่งคืน"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["data-bs-content"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }, null, -1))
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "row-hover",
                  onClick: ($event: any) => (_ctx.selectedClick(project.id))
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", {
                    class: "column-name text-truncate",
                    "data-bs-toggle": "popover-project",
                    "data-bs-content": project.name
                  }, [
                    _hoisted_6,
                    _createTextVNode(_toDisplayString(project.name), 1)
                  ], 8, _hoisted_5),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(Number(project.projectBudgets.filter(m => m.id !== 4).reduce((total, m) => total + (m.amount ? m.amount : 0), 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1),
                  _withDirectives(_createElementVNode("td", _hoisted_8, null, 512), [
                    [_directive_dompurify_html, (project.projectStatus.key > 1) ? (project.projectResult) ? Number(project.projectResult.realBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' : '-']
                  ]),
                  _withDirectives(_createElementVNode("td", _hoisted_9, null, 512), [
                    [_directive_dompurify_html, (project.projectStatus.key > 1) ? (project.projectResult) ? Number(project.projectResult.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' : '-']
                  ]),
                  _withDirectives(_createElementVNode("td", null, null, 512), [
                    [_directive_dompurify_html, _ctx.status(project.isCanceled, project.projectStatus.name, project.projectStatus.color)]
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ])
          ], 512)
        ]))
  ]))
}